var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.026143mm",
    height: "10.599386mm",
    viewBox: "0 0 13.026143 10.599386",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-418.07997,-228.43267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6-4-2-2",
    transform: "rotate(-90,349.31746,150.04967)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.451826,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 268.4651,173.14083 -1.73182,2.93429 1.25255,1.78459 2.41523,-0.14387 1.16636,-1.90187 -1.51499,-2.76724 z",
    id: "path6-7-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5-1-6-2-7-9-0",
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.753944,
      paintOrder: "stroke fill markers"
    },
    d: "m 268.49971,172.3076 -1.63169,0.73558 -0.33817,3.90004 2.96956,3.03785 3.27435,-2.93732 -0.53376,-4.4151 z m 1.22494,1.15482 1.81246,2.4008 -1.32544,-0.47302 0.33273,1.98082 -0.87896,-0.61327 -0.75741,0.52989 0.24239,-1.96677 -1.31843,0.59299 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLeft);
export default __webpack_public_path__ + "static/media/MoveLeft.e427d871a22f1ab04042e7279d870a76.svg";
export { ForwardRef as ReactComponent };